import {createLogic} from 'redux-logic';
import gql from 'graphql-tag';

import {applicationClient as client} from 'App/index';

import {
  authLogout,
  authLogoutError,
  authLogoutSuccess,
} from '../actions';

import {selectors as authSel} from '../reducer';

export const authLogoutLogic = createLogic({
  type: authLogout,
  // cancelType: [],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false,
  },

  validate({getState, action}, allow, reject) {
    const state = getState();
    if (authSel.user(state) !== null) {
      // already authenticated just silently reject
      allow(action);
    } else {
      return reject();
    }
  },

  process({action}, dispatch, done) {
    const {cb_success} = action.payload;
    performLogout()
      .then(result => {
        // if login does not work, it returns NULL
        dispatch(
          authLogoutSuccess(cb_success)
        );
      })
      .catch(
        (err) => {
          dispatch(authLogoutError(err.toString().replace('Error: GraphQL error: ', '')));
        }
      )
      .then(() => done());
  }
});

let performLogout = () => {
  return client
    .query({
      query: gql`
        query {
          logout
        }`
    });
};

export const authLogoutSuccessLogic = createLogic({
  type: authLogoutSuccess,
  // cancelType: [],
  latest: false, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action}, dispatch, done) {
    // call callback function
    action.payload.cb_success(dispatch);

    done();
  }
});


// WEBPACK FOOTER //
// ./src/util/redux/auth/logic/logout.js